import { styled } from "@mui/material/styles";
import Tooltip, { tooltipClasses, TooltipProps } from "@mui/material/Tooltip";

const WorkSpaceStyledTooltip = styled(
  ({ className, ...props }: TooltipProps) => (
    <Tooltip {...props} classes={{ popper: className }} />
  )
)(() => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: "#ffff",
    color: "rgba(0, 0, 0, 0.87)",
    border: "1px solid #dadde9",
    fontSize: 15,
    cursor: "pointer",
    minWidth: 300,
  },
  [`& .${tooltipClasses.arrow}`]: {
    color: "#ffff",
    "&:before": {
      backgroundColor: "#ffff",
      border: "1px solid #dadde9",
    },
  },
}));

export default WorkSpaceStyledTooltip;
